<template>
    <div class="finance">
        <van-nav-bar
                fixed
                title="财税平衡信息和评分"
                left-arrow
                @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="hhb-view">
            <detail-view v-model="info" :attrs="attrs" :opts="opts"/>
        </div>
    </div>
</template>

<script>
    import DetailView from "@/components/detail/index";
    import {dateFormat} from '@/utils/common-api'

    export default {
        name: "finance",
        components: {DetailView},
        data() {
            return {
                info: {},
                opts: {
                    projectType: [
                        {value: '100', label: '第一产业'},
                        {value: '101', label: '第二产业'},
                        {value: '102', label: '第三产业'},
                        {value: '103', label: '一二三类融合'},
                        {value: '0', label: '科研'}
                    ],
                    assetsType: [
                        {value: '0', label: '轻资产'},
                        {value: '100', label: '重资产'}
                    ]
                },
                attrs: [
                    {
                        head: {
                            title: '财税平衡信息和评分'
                        },
                        body: [
                            {type: 'text', name: 'subIndustry', title: '所属行业：'},
                            {type: 'text', name: 'taxRate', title: '综合税率：'},
                            {type: 'text', name: 'rate', title: '区级存留：'},
                            {type: 'select', name: 'projectType', title: '项目类型：'},
                            {type: 'select', name: 'assetsType', title: '资产类型：'},
                            {
                                type: 'table', name: 'taxList', columns: [
                                    {title: '年度', field: 'taxYear'},
                                    {title: '开票收入（万元）', field: 'income'},
                                    {title: '综合税率（万元）', field: 'taxRate'},
                                    {title: '区级税收（万元）', field: 'incomeTax'},
                                    {title: '区级存比例', field: 'areaTaxRate'},
                                    {title: '企业税收贡献（万元）', field: 'qysr'}
                                ]
                            },
                            {type: 'text-tip-right', name: 'totalAmount'}
                        ]
                    },
                    {
                        head: {
                            title: '扶持政策'
                        },
                        body: [
                            {type: 'text', title: '税收补贴：'},
                            {type: 'text-tip', name: 'taxSubsidyText'},
                            {type: 'text-tip', title: '备注：', name: 'remake'},
                            {type: 'driver'},
                            {type: 'text', title: '装修补贴：'},
                            {
                                type: 'table', name: 'decorationDataList', columns: [
                                    {title: '项目', field: 'decorationName'},
                                    {title: '面积（平方米）', field: 'decorationArea'},
                                    {title: '单价（每平方米/元）', field: 'decorationPrice'},
                                    {title: '金额（万元）', field: 'totalAmount'}
                                ]
                            },
                            {type: 'text-tip-right', name: 'decorationSubsidyText'},
                            {type: 'text-tip', title: '备注：', name: 'zxremake'},
                            {type: 'driver'},
                            {type: 'text', title: '租金补贴：'},
                            {
                                type: 'table', name: 'rentDataList', columns: [
                                    {title: '项目', field: 'rentName'},
                                    {title: '面积（平方米）', field: 'rentArea'},
                                    {title: '单价（每平方米/元）', field: 'rentPrice'},
                                    {title: '年数', field: 'rentYears'},
                                    {title: '金额（万元）', field: 'totalAmount'}
                                ]
                            },
                            {type: 'text-tip', name: 'rentSubsidyText'},
                            {type: 'text-tip', title: '备注：', name: 'zjremake'},
                            {type: 'driver'},
                            {type: 'text', title: '研发补贴：'},
                            {
                                type: 'table', name: 'rdDataList', columns: [
                                    {title: '内容', field: 'description'},
                                    {title: '金额（万元）', field: 'subsidyMoney'}
                                ]
                            },
                            {type: 'text-tip-right', name: 'rdSubsidyText'},
                            {type: 'text-tip', title: '比例：', name: 'yfbili'},
                            {type: 'text-tip', title: '起始年月：', name: 'yfstartMonth'},
                            {type: 'text-tip', title: '截止年月：', name: 'yfendMonth'},
                            {type: 'text-tip', title: '备注：', name: 'yfremake'},
                            {type: 'driver'},
                            {type: 'text', title: '设备补贴：'},
                            {
                                type: 'table', name: 'equipmentDataList', columns: [
                                    {title: '内容', field: 'description'},
                                    {title: '金额（万元）', field: 'subsidyMoney'}
                                ]
                            },
                            {type: 'text-tip-right', name: 'equipmentSubsidyText'},
                            {type: 'text-tip', title: '比例：', name: 'sbbili'},
                            {type: 'text-tip', title: '起始年月：', name: 'sbstartMonth'},
                            {type: 'text-tip', title: '截止年月：', name: 'sbendMonth'},
                            {type: 'text-tip', title: '备注：', name: 'sbremake'},
                            {type: 'driver'},
                            {type: 'text', title: '其他补贴：'},
                            {
                                type: 'table', name: 'otherDataList', columns: [
                                    {title: '内容', field: 'description'},
                                    {title: '金额（万元）', field: 'subsidyMoney'}
                                ]
                            },
                            {type: 'text-tip-right', name: 'otherSubsidyText'},
                            {type: 'text-tip', title: '备注：', name: 'qtremake'},
                            {type: 'text-link', name: 'summaryText'},
                        ]
                    }
                ]
            };
        },
        methods: {
            requestData() {
                this.info = {};
                this.$toast.loading('加载中...');
                this.request({
                    url: "/v1.0/Project/getProjectTax",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    const {subIndustry, taxRate, rate, projectType, assetsType, taxList, totalAmount} = res.data;
                    const newTotalAmount = this.getFValue(totalAmount, 2, 0);
                    this.$set(this.info, 'subIndustry', subIndustry);
                    this.$set(this.info, 'taxRate', taxRate !== undefined ? taxRate + '%' : '');
                    this.$set(this.info, 'rate', rate !== undefined ? rate + '%' : '');
                    console.log(projectType);
                    this.$set(this.info, 'projectType', projectType);
                    this.$set(this.info, 'assetsType', assetsType);
                    taxList.forEach(item=>{
                        if(item.isShouDong){
                            item.areaTaxRate = '无';
                        }else{
                            item.qysr = Math.floor(item.incomeTax * item.areaTaxRate/1 * 100)/100;
                        }
                    })
                    this.$set(this.info, 'taxList', taxList);
                    this.$set(this.info, 'totalAmount', `总金额(万元)：${newTotalAmount}`);
                    this.$toast.clear();
                }).catch(() => {
                    this.$toast.clear();
                });
            },
            requestData2() {
                this.request({
                    url: "/v1.0/Project/getProjectSubsidies",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    const {
                        totalAmount,        // 补贴总金额
                        taxSubsidy,         // 税收补贴
                        decorationSubsidy,  // 装修补贴
                        rentSubsidy,        // 租金补贴
                        rdSubsidy,          // 研发补贴
                        equipmentSubsidy,   // 设备补贴
                        otherSubsidy        // 其他补贴
                    } = res.data;

                    // 设置税收补贴
                    this.setTaxSubsidy(taxSubsidy);

                    // 设置装修补贴
                    this.setDecorationSubsidy(decorationSubsidy);

                    // 设置租金补贴
                    this.setRentSubsidy(rentSubsidy);

                    // 设置研发补贴
                    this.setRdSubsidy(rdSubsidy);

                    // 设置设备补贴
                    this.setEquipmentSubsidy(equipmentSubsidy);

                    // 设置其他补贴
                    this.setOtherSubsidy(otherSubsidy);

                    // 更新政策扶持总金额；并组装汇总信息
                    this.$set(this.info, 'totalAmount_summary', this.getFValue(totalAmount, 2));
                    this.setSummaryInfo();
                }).catch(() => {
                });
            },
            requestData3() {
                this.request({
                    url: "/v1.0/Project/computeFiscalTaxScore",
                    method: "get",
                    params: {
                        projectId: this.getId,
                    },
                }).then((res) => {
                    const {score} = res.data;
                    // 更新财税平衡评分；并组装汇总信息
                    this.$set(this.info, 'score_summary', score);
                    this.setSummaryInfo();
                }).catch(() => {
                });
            },
            getSValue(val, def) {
                return val !== undefined && val !== null && val !== '' ? val : def;
            },
            getFValue(val, len, def) {
                return val !== undefined && val !== null ? parseFloat(val.toFixed(len)) : (def !== undefined && def !== null ? def : '');
            },
            getFValuePercent(val, len, def) {
                return val !== undefined && val !== null ? parseFloat((val / 100).toFixed(len)) : (def !== undefined && def !== null ? def : '');
            },
            // 设置税收补贴
            setTaxSubsidy(data) {
                console.log('----',data);
                let {
                    fullReturnYear: p1,
                    fullReturnYearPercent: p2,
                    halfReturnYear: p3,
                    halfReturnYearPercent: p4,
                    totalAmount: p5,
                    remake
                } = data || {};
                p1 = this.getFValue(p1, 0, 0);
                p2 = this.getFValue(p2, 0, 0);
                p3 = this.getFValue(p3, 0, 0);
                p4 = this.getFValue(p4, 2, 0);
                p5 = this.getFValue(p5, 2, 0);
                const taxSubsidyText = `前 ${p1} 年 ${p2}% 返还；后 ${p3} 年 ${p4}% 返还；总金额（万元）：${p5}`;
                this.$set(this.info, 'taxSubsidyText', taxSubsidyText);
                this.$set(this.info, 'remake', remake);
            },
            // 设置装修补贴
            setDecorationSubsidy(data) {
                let {
                    totalAmount: p1,
                    decorationDatas: dataList,
                    remake
                } = data || {};
                p1 = this.getFValue(p1, 2, 0);
                const decorationSubsidyText = `总金额(万元)：${p1}`;
                this.$set(this.info, 'decorationDataList', dataList);
                this.$set(this.info, 'decorationSubsidyText', decorationSubsidyText);
                this.$set(this.info, 'zxremake', remake);
            },
            // 设置租金补贴
            setRentSubsidy(data) {
                let {
                    fullReturnYear: p1,
                    fullReturnYearPercent: p2,
                    halfReturnYear: p3,
                    halfReturnYearPercent: p4,
                    totalAmount: p5,
                    rentDatas: dataList,
                    remake
                } = data || {};
                p1 = this.getFValue(p1, 0, 0);
                p2 = this.getFValuePercent(p2, 0, 0);
                p3 = this.getFValue(p3, 0, 0);
                p4 = this.getFValuePercent(p4, 2, 0);
                p5 = this.getFValue(p5, 2, 0);
                const rentSubsidyText = `前 ${p1} 年 ${p2}% 返还；后 ${p3} 年 ${p4}% 返还；总金额（万元）：${p5}`;
                this.$set(this.info, 'rentDataList', dataList);
                this.$set(this.info, 'rentSubsidyText', rentSubsidyText);
                this.$set(this.info, 'zjremake', remake);
                
            },
            // 设置研发补贴
            setRdSubsidy(data) {
                let {
                    totalAmount: p1,
                    subsidyDatas: dataList,
                    remake,
                    startMonth,
                    endMonth,
                    bili
                } = data || {};
                p1 = this.getFValue(p1, 2, 0);
                const rdSubsidyText = `总金额(万元)：${p1}`;
                this.$set(this.info, 'rdDataList', dataList);
                this.$set(this.info, 'rdSubsidyText', rdSubsidyText);
                this.$set(this.info, 'yfremake', remake);
                this.$set(this.info, 'yfstartMonth', dateFormat(startMonth, 'YYYY年M月'));
                this.$set(this.info, 'yfendMonth', dateFormat(endMonth, 'YYYY年M月'));
                this.$set(this.info, 'yfbili', bili + '%');
                
            },
            // 设置设备补贴
            setEquipmentSubsidy(data) {
                let {
                    totalAmount: p1,
                    subsidyDatas: dataList,
                    remake,
                    startMonth,
                    endMonth,
                    bili
                } = data || {};
                p1 = this.getFValue(p1, 2, 0);
                const equipmentSubsidyText = `总金额(万元)：${p1}`;
                this.$set(this.info, 'equipmentDataList', dataList);
                this.$set(this.info, 'equipmentSubsidyText', equipmentSubsidyText);
                this.$set(this.info, 'sbremake', remake);
                this.$set(this.info, 'sbstartMonth', dateFormat(startMonth, 'YYYY年M月'));
                this.$set(this.info, 'sbendMonth', dateFormat(endMonth, 'YYYY年M月'));
                this.$set(this.info, 'sbbili', bili + '%');
            },
            // 设置其他补贴
            setOtherSubsidy(data) {
                let {
                    totalAmount: p1,
                    subsidyDatas: dataList,
                    remake
                } = data || {};
                p1 = this.getFValue(p1, 2, 0);
                const decorationSubsidyText = `总金额(万元)：${p1}`;
                this.$set(this.info, 'otherDataList', dataList);
                this.$set(this.info, 'otherSubsidyText', decorationSubsidyText);
                this.$set(this.info, 'qtremake', remake);
            },
            // 设置汇总信息
            setSummaryInfo() {
                const {totalAmount_summary, score_summary} = this.info;
                const summaryText = `政策扶持总金额(): ${totalAmount_summary}万元；财税平衡评分：${score_summary}分。`;
                this.$set(this.info, 'summaryText', summaryText);
            }
        },
        computed: {
            getId() {
                return this.$route.query.id;
            }
        },
        created() {
            this.requestData();
            this.requestData2();
            this.requestData3();
        }
    }
</script>

<style lang="scss" scoped>
</style>